import React, {useCallback, useState} from 'react';
import {withLocalize} from 'react-localize-redux';

import {
    useRouteMatch
} from 'react-router-dom';

import useTabTopics from '../../../../useHook/useTabTopics';
import Tabs from '../../../../components/Tabs';

function TabTeam() {
    const {url} = useRouteMatch();

    const {menus, menuHelper, onUpdateTitleTopic, onCreateTopic} = useTabTopics('team', [
        {name: '定型レポート', to: `${url}`, exact: true},
        {name: '投手一覧', to: `${url}/pitcher`, exact: false},
        {name: '野手一覧', to: `${url}/batter`, exact: false},
        {name: 'スタメン', to: `${url}/starter`, exact: false},
        {name: '公示', to: `${url}/public`, exact: false},
        {name: 'スケジュール', to: `${url}/schedule`, exact: false},
    ]);

    const [editIndex, setEditIndex] = useState(-1);

    const onSaveTitle = useCallback(async (item, index) => {
        setEditIndex(-1);
        await onUpdateTitleTopic({
            topicId: item.id,
            title: item.name,
        });
        setEditIndex(-1);
        menuHelper.updateAt(index, item)
    }, []);

    const onUpdateTitle = useCallback((index) => {
        setEditIndex(index)
    }, []);

    const onAddFreeTopic = useCallback((useDefault) => {
        onCreateTopic(useDefault);
    }, []);

    return (
        <Tabs menuList={menus}
            popupList={[
                { value: 0, name: 'Free Topicsを追加'},
                { value: 1, name: 'Team Topicsを追加'},
            ]}
            editIndex={editIndex}
            onAddFreeTopic={onAddFreeTopic}
            onSaveTitle={onSaveTitle}
            onUpdateTitle={onUpdateTitle}
        />
    );
}

export default withLocalize(TabTeam);
